import React, { useState } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Descriptions } from 'antd';
import styled from 'styled-components';

const BDOCustomerDescription = ({ customerInformation }) => {
  const [isMoreDetailsVisible, setMoreDetailsVisible] = useState(false);
  return (
    <>
      <StyledDescriptions column={{ sm: 2, xs: 1 }} colon={false} layout="horizontal" title="">
        {Object.keys(customerInformation)
          .slice(0, 16)
          .map((key, index) => {
            const value = customerInformation[key];
            return (
              <StyledDescriptions.Item key={key} label={key}>
                {value || '-'}
              </StyledDescriptions.Item>
            );
          })}
      </StyledDescriptions>
      <StyledDescriptions
        style={{
          height: isMoreDetailsVisible ? '220px' : '0px',
          transition: 'all 0.3s ease-out',
          overflow: 'hidden'
        }}
        className="mike"
        column={{ sm: 2, xs: 1 }}
        colon={false}
        layout="horizontal"
        title={null}
      >
        {Object.keys(customerInformation)
          .slice(16)
          .map((key, index) => {
            const value = customerInformation[key];
            return (
              <StyledDescriptions.Item key={key} label={key}>
                {value || '-'}
              </StyledDescriptions.Item>
            );
          })}
      </StyledDescriptions>
      <div
        style={{ color: 'blue', cursor: 'pointer', marginTop: '1rem' }}
        onClick={() => setMoreDetailsVisible(prv => !prv)}
      >
        {isMoreDetailsVisible ? (
          <>
            <UpOutlined /> <span style={{ marginLeft: '4px' }}>Hide details</span>
          </>
        ) : (
          <>
            <DownOutlined /> <span style={{ marginLeft: '4px' }}>Show more details</span>
          </>
        )}
      </div>
    </>
  );
};

export default BDOCustomerDescription;

const StyledDescriptions = styled(Descriptions)`
  .ant-descriptions-item-label {
    width: 160px;
    vertical-align: top;
  }

  .ant-descriptions-item-content {
    width: 240px;
  }
`;
